import {
  createSearchOffersDesktopModel,
  TSearchOffersDesktopRequestSchema,
  TSearchOffersDesktopResponseSchema,
} from '../../repositories/search-offers/v2/search-offers-desktop';
import { IHttpApi } from '@cian/http-api/shared';

export function getOffers(
  httpApi: IHttpApi,
  parameters?: TSearchOffersDesktopRequestSchema,
): Promise<TSearchOffersDesktopResponseSchema> {
  return httpApi.fetch(
    // Typescript воспринимает parameters как ISearchOffersDesktopJsonQueryRequestSchema,
    // но хочет поля из ISearchOffersDesktopPathRequestSchema
    // tslint:disable-next-line:no-any
    createSearchOffersDesktopModel({ parameters } as any) as any,
    undefined,
  );
}
